import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

import { useFlow } from './FlowContext';
import { DataContext1 } from './DataContext1';
import { DataContext2 } from './DataContext2';
import { DataContext3 } from './DataContext3';
import { DataContext4 } from './DataContext4';
import { useSearchParams } from 'react-router-dom';

// Create the context
const DataContext = createContext();

// Create a provider component
const DataContextProvider = ({ children }) => {
  const { setFlowNumber, flowNumber } = useFlow();
  const [searchParams] = useSearchParams();
  if (searchParams.get('id')?.length)
    localStorage.setItem('shopId', searchParams.get('id'));
  const props = useContext(
    flowNumber === 1
      ? DataContext1
      : flowNumber === 2
        ? DataContext2
        : flowNumber === 3
          ? DataContext3
          : DataContext4
  );

  return (
    <DataContext.Provider
      value={{
        ...props,
        flowNumber,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataContextProvider };
